import * as primitives from './primitives';
import * as mobile from './primitives.native';
export default primitives;
export { mobile, primitives };